import Vue from 'vue';
import { Fragment } from 'vue-frag';
import AppAcForm from '../vue/apps/ac-form.vue';

export function setupVue() {
    const appAcFormSelector = document.querySelectorAll('[data-form]');

    if (appAcFormSelector) {

        Vue.component('Fragment', Fragment);

        Vue.config.productionTip = false;

        if (appAcFormSelector) {

            appAcFormSelector.forEach(acForm => {
                const formId = acForm.dataset.formId,
                    formKey = acForm.dataset.formKey;

                if (formId) {
                    new Vue({
                        name: 'AcForm',
                        data: {
                            formId,
                            formKey
                        },
                        render: h => h(AppAcForm)
                    }).$mount(acForm);
                }
            });
        }
    }
}
